/**
 * @desc 活动模块
 */
const sysActivityList = r => require.ensure([], () => r(require('../views/activity/SysActivityList.vue')), 'sysActivityList');
const schoolActivityList = r => require.ensure([], () => r(require('../views/activity/SchoolActivityList.vue')), 'schoolActivityList');
const institutionActivityList = r => require.ensure([], () => r(require('../views/activity/InstitutionActivityList.vue')), 'institutionActivityList');

export default [
  //平台活动列表
  {
    name: 'sysActivityList',
    path: '/sysActivityList',
    component: sysActivityList,
    meta: { title: '平台活动' },
  },
  //学校活动列表
  {
    name: 'schoolActivityList',
    path: '/schoolActivityList',
    component: schoolActivityList,
    meta: { title: '学校活动' },
  },
  //课程方活动列表
  {
    name: 'institutionActivityList',
    path: '/institutionActivityList',
    component: institutionActivityList,
    meta: { title: '课程方活动' },
  }
]